import { create } from "@storybook/theming";

export const theme = create({
  base: "dark",
  brandTitle: "Coradion",
  brandUrl: "https://coradion.com",
  brandImage: "https://place-hold.it/350x150",
  brandTarget: "_blank",
});
